<template>
  <div>
    <div class="newsDetails">
      <div class="middle auto_div news_panel bgf">
        <div class="container-fluid">
          <div class="row news_content_panel" style="margin-top:0px; padding-bottom:20px;">
            <div id="ContentView">
              <div class="ContentViewTit">
                <div
                  class="h3 text-center"
                  style="margin-top: 20; margin-bottom: 10px; font-size: 18px;line-height:36px;padding-bottom: 8px;"
                >
                  {{ newsitem.title }}
                </div>
              <div style="color: #caccce;font-size: 14px;">发布时间：{{ dayjs(newsitem.publishDate).format('YYYY-MM-DD') }}</div>
              </div>
              <div style="background-color:#f7ebec; height:2px; margin:10px auto"></div>
              <div class="content_body nrstyle" v-html="newsitem.content" style="overflow-x: auto;">
              </div>
              <div class="tz">
                <div class="u" v-if="newsitem.upArtUuid !== '0'">
                  <a @click="((val)=>{todel(val,newsitem.upArtUuid)})">上一篇：{{ newsitem.upArtTitle }}</a>
                </div>
                <div class="d" v-if="newsitem.downArtUuid !== '0'">
                  <a @click="((val)=>{todel(val,newsitem.downArtUuid)})">下一篇：{{ newsitem.downArtTitle }}</a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { getArtInfo ,increaseViews} from '@/api/common'
export default {
  props: {
    parentId: {
      type: String,
      default: ''
    },
    id: {
      type: String,
      default: ''
    },
    name: {
      type: String,
      default: ''
    },
  },
  data() {
    return {
      newsitem: {}
    }
  },
  mounted() {
    var _this = this
    this.$nextTick(() => {
      _this.getArtInfo(_this.id)
      _this.increaseViews(_this.id)
    })
    
  },
  methods: {
    todel(val,entTArticleUuid){
      this.getArtInfo(entTArticleUuid)
      this.increaseViews(entTArticleUuid)
    },
    getArtInfo(id) {
      var _this = this
      var applicationId = ''
      _this.newsitem = {}
      if (_this.$route.params.id == '00550003') {
        applicationId = _this.webIdGroup
      } else {
        applicationId = _this.webId
      }
      let data = {
        entTApplicationUuid: applicationId,
        entTArticleUuid: id
      }
      getArtInfo(data).then(res => {
        const { code, data } = res
        if (code === 1 && data) {
          _this.newsitem = data
        }
      })
    },
    increaseViews(id){
      let data = {
        entTArticleUuid: id
      }
      increaseViews(data).then(res => {
        const { code, data } = res
        if (code === 1 && data) {
          // _this.dataView = data
          // console.log(111,_this.dataView)
        }
      })
    }
  }
}
</script>

<style>
.ContentViewTit {
  text-align: center;
}
.newsDetails {
  width: 910px;
  overflow: hidden;
  margin: 0 auto;
  padding: 30px 5px;
  background-color: #ffffff;
  line-height: 24px;
  box-sizing: border-box;
}

.newsDetails .auto_div {
  width: auto;
  height: auto;
  overflow: hidden;
}
.newsDetails .width_100 {
  width: 100% !important;
}
.newsDetails .container-fluid {
  padding-right: 0px;
  padding-left: 0px;
  margin-right: auto;
  margin-left: auto;
}
.newsDetails .news_panel .news_content_panel {
  width: auto;
  overflow: hidden;
}
.newsDetails .row {
  margin-right: 0px;
  margin-left: 0px;
}
.newsDetails #ContentView {
  /* width: 1200px; */
  overflow: hidden;
  margin: 0 auto;
  padding: 30px 5px;
  background-color: #ffffff;
  line-height: 24px;
}
.newsDetails .nrstyle {
  font-family: '宋体';
  font-size: 18px;
  line-height: 30px;
}
.newsDetails .clear {
  width: 100%;
  height: 10px;
  clear: both;
  overflow: hidden;
}
.newsDetails #ContentView .des {
  font-size: 14px;
  height: 40px;
  color: #caccce;
  line-height: 30px;
  margin: 10px 0px;
  padding-bottom: 10px;
}
.newsDetails #ContentView .tz {
  padding: 10px 0px;
  margin-top: 10px;
  text-align: left;
  cursor: pointer;
}
.newsDetails #ContentView .tz a {
  font-size: 16px;
  display: inline-block;
  padding: 5px 0px;
}
.newsDetails a {
  color: #333;
}
.newsDetails a,
a {
  text-decoration: none;
}
</style>
